/**
 * 分类选择组件
 * @description 分类选择组件
 * @author mll
 * @date 2020-5-7
 */
import React from 'react';
import { connect } from 'dva';

import { framework_tool, component_tool, utils_tool } from '@/tool'
import { modelUtils } from "@/utils";
let { WizContainer } = framework_tool;
let {
    WizSelect,
    WizModal,
    WizTreeSelectList,
} = component_tool;

class WizClassifySelect extends WizContainer {

    componentName = 'WizClassifySelect';

    constructor(props) {
        super(props);
        this.state = {
            stateSelects: props.initSelects || [],
            rowData: new Date().getTime(),
        }
    }

    static defaultProps = {
        onChange: () => { },//点击modal 确定的回调方法
        value: [],//已选数据,
        modalProps: {},//modal的参数
        selectProps: {},//输入框的参数
        wizTreeSelectListProps: {},//WizTreeSelectList的参数
        apiProps: {},//调用分类接口的参数
        apiPath: 'questionType/nodeList',//api的redux动态模型的请求patg
        returnKey: false,//onChange返回数据是否需要key，默认返回对象
    };


    /**
     * 初始化时根据record判断是新增还是编辑
     */
    _componentDidMount() {
        let { apiProps, apiPath } = this.props
        this.doActions([
            {
                path: apiPath,
                payload: {
                    key: `questionType@treeData${apiProps&&apiProps.type||''}`,
                    apiParams: { state: 1, ...apiProps }
                }
            }
        ])
    }

    propsAndStateOnChange = {
        treeData: this._getDataOver.bind(this),
        value: this._valueChange.bind(this)
    }

    _valueChange(nextProps, nextState) {
        let { value } = nextProps;
        if(Object.prototype.toString.call(value) === '[object Object]') {
            if(value._SEARCHBAR) {
                nextState['value'] = value.value || []
                nextState['stateSelects'] = value.stateSelects || []
                nextState['rowData'] = new Date().getTime()
            }
        } else if (!value || !value.length) {
            nextState['stateSelects'] = []
            nextState['rowData'] = new Date().getTime()
        }

        return true;
    }
    _getDataOver(nextProps, nextState) {
        if (nextProps.treeData.code == 1) {
            if (nextProps.treeData.data && (nextProps.treeData.data instanceof Array)) {
                nextProps.treeData.data.forEach(data => {
                    this.giveKey(data)
                });
            }
        }
        return true;
    }

    /**给数据加key */
    giveKey(data) {
        data.key = data.value;
        if (data.children && data.children instanceof Array) {
            data.children.forEach(children => {
                this.giveKey(children)
            })
        }
    }

    _treeSelectOnClick() {
        this.setState({
            modalVisible: true,
        });
    }

    _wizSelectOnSubmit() {
        let { returnKey, onChange, _SEARCHBAR } = this.props
        let { stateSelects } = this.state
        let _stateSelects = [...stateSelects]
        this.setState({
            modalVisible: false,
            rowData: new Date().getTime(),
        }, () => {
            if(_SEARCHBAR) {
                onChange && onChange({ _SEARCHBAR, value: _stateSelects.map(select => select.key), initSelects: _stateSelects })
            } else {
                onChange && onChange(
                    returnKey ?
                        _stateSelects.map(select => select.key)
                        :
                        _stateSelects
                );
            }
        });
    }

    _wizSelectOnCancel() {
        let { stateSelects } = this.state
        let { returnKey, value } = this.props

        let _value = JSON.parse(JSON.stringify(value)), _stateSelects = JSON.parse(JSON.stringify(stateSelects));
        if(value._SEARCHBAR) {
            _value = value.value
            _stateSelects = value.initSelects
 
        } else{
            if (returnKey) {
                _value.forEach(v => {
                    stateSelects.forEach(s => {
                        if (v === s['key']) {
                            _stateSelects.push(s)
                        }
                    });
                });
            } else {
                _stateSelects = _value
            }
        }

        this.setState({
            modalVisible: false,
            rowData: new Date().getTime(),
            stateSelects: _stateSelects,
        });
    }

    _renderOptions(propsSelects) {
        if (propsSelects && propsSelects.length) {
            return propsSelects.map((row, i) => this._renderOption(row))
        }
        return null
    }

    _renderOption(row) {
        if (row) {
            return (
                <WizSelect.Option key={row['key']} value={row['title']} title={row['title']}>
                    {row['title']}
                </WizSelect.Option>
            )
        }
    }

    _wizSelectOnChange(value, option) {
        const { _SEARCHBAR, onChange, returnKey } = this.props
        let classify = value.map(select => select.key)
        let stateSelects = this.state.stateSelects.filter(filter => classify.indexOf(filter.key) !== -1)
        this.setState({
            stateSelects: stateSelects,
            rowData: new Date().getTime(),
        }, () => {
            if(_SEARCHBAR) {
                onChange && onChange({ _SEARCHBAR, value: classify, initSelects: value })
            } else {
                onChange(
                    returnKey ?
                        classify
                        :
                        value
                );
            }
            
        });
    }


    _render() {
        let { value, modalProps, wizTreeSelectListProps, selectProps, returnKey } = this.props
        const { modalVisible, stateSelects, rowData } = this.state
        let _value = JSON.parse(JSON.stringify(value)), _stateSelects = JSON.parse(JSON.stringify(stateSelects));


        if(value._SEARCHBAR) {
            _value = value.value
            _stateSelects = value.initSelects
        }
        let defaultValue = []
        if (returnKey) {
          _stateSelects.forEach(s => {
            if (typeof _value === 'string' ? _value === s['key'] : _value?.indexOf(s['key']) !== -1) {
              defaultValue.push({ key: s.key, label: s.title || s.label })
            }
          });
        } else {
            defaultValue = _value.map(select => { return { key: select.key, label: select.title || select.label } })
        }


        let treeData = this.props.treeData.data ? this.props.treeData.data : [];
        let selectKey = defaultValue.map(select => select.key).join(",")
        return (
            <>
                <div onClick={() => this._treeSelectOnClick()}>
                    <WizSelect
                        key={'wizSelect_' + selectKey}
                        mode={'multiple'}
                        placeholder={'请选择分类'}
                        labelInValue
                        {...selectProps}
                        defaultValue={defaultValue}
                        open={false}
                        onChange={(value, option) => this._wizSelectOnChange(value, option)}
                    >
                        {this._renderOptions(_stateSelects)}
                    </WizSelect>
                </div>
                {treeData ?
                    <WizModal
                        title={'选择'}
                        width={1000}
                        style={{ top: 20 }}
                        {...modalProps}
                        visible={modalVisible}
                        maskClosable={false}
                        onOk={e => this._wizSelectOnSubmit(e)}
                        onCancel={e => this._wizSelectOnCancel(e)}
                    >
                        <WizTreeSelectList
                            key={'WizTreeSelectList_' + rowData}
                            {...wizTreeSelectListProps}
                            treeData={treeData}
                            checkedKeys={_stateSelects.map(select => select.key)}
                            listCheck={_stateSelects}
                            onChange={(selects) => {
                                this.setState({
                                    stateSelects: selects,
                                });
                            }}
                        />
                    </WizModal>
                    : null}
            </>)
    }
}

const mapStateToProps = (state, ownProps) => {
    const { questionType } = state;
    const { apiProps } = ownProps;
    
    const treeData = modelUtils.getModelEntity(questionType, `questionType@treeData${apiProps&&apiProps.type||''}`);
    const load = modelUtils.getLoadingState(state, "selects");

    return {
        treeData,
        ...load
    }
};

const options = { withRef: true };
export default connect(mapStateToProps, null, null, options)(WizClassifySelect);

